import { format, isValid, parse } from 'date-fns'
import React, { Fragment } from 'react'

import { Card, LineItem } from '@/components'
import { PropertyQueries } from '@/graphql/queries/property.queries'
import { useGraphql } from '@/hooks/useGraphql'
import { ReservationProperty } from '@/types/Property'

import { officeHourMapping } from './PropertyView.data'

export function PropertyDetail({ propertyId }: { propertyId: number }) {
  const { data } = useGraphql<{ property: ReservationProperty }>(
    PropertyQueries.QUERY_KEYS.getReservationProperty,
    PropertyQueries.getReservationProperty(),
    { id: propertyId },
    {
      enabled: !!propertyId,
    },
  )

  const propertyDetails = data?.property
  const { name, address1, state, zip, contacts, smartLockInstallApproval } = propertyDetails || {}

  const todayFields = officeHourMapping[new Date().getDay()]

  const todayTimings =
    propertyDetails && todayFields && propertyDetails[todayFields.open]
      ? `${getFormatedTime(propertyDetails[todayFields.open])} - ${getFormatedTime(
          propertyDetails[todayFields.close],
        )} `
      : undefined

  const smartLockStatus = ['Unknown', 'Yes', 'NO']
  const smartLockValue = smartLockInstallApproval ? smartLockStatus[smartLockInstallApproval || 0] : undefined

  function getFormatedTime(time?: string) {
    if (time && isValid(parse(time, 'HH:mm:ss', new Date()))) {
      return format(new Date(`July 1, 1999,${time}`), 'hh:mm a')
    }
    return 'N/A'
  }

  return (
    <>
      {propertyDetails && (
        <div>
          <Card cardClassName="mb-4">
            <div className="flex w-full flex-col px-4">
              <LineItem label="Name" value={name} />
              <LineItem label="Address" last={!todayTimings} value={`${address1}, ${state}-${zip} `} />
              {todayTimings && <LineItem label="Office Hours" last={true} value={todayTimings} />}
              <LineItem booleanCheck={true} label="Direct" tag="info" value={propertyDetails?.landingDirect} />
            </div>
          </Card>
          <Card cardClassName="mb-4">
            <div className="flex w-full flex-col px-4">
              <LineItem label="Management Company" value={propertyDetails.managementCompany?.name} />
              <LineItem
                label="Landing Living LLC Status"
                tag={propertyDetails.landingLivingApplicationStatus ? 'success' : 'none'}
                value={propertyDetails.landingLivingApplicationStatus}
              />
              <LineItem label="Screening Required" value={propertyDetails.propertyScreeningRequired} />
              <LineItem label="Smart Lock Approval" last={true} tag="info" value={smartLockValue} />
            </div>
          </Card>
          {contacts && contacts.length > 0 && (
            <Card cardClassName="mb-4" headerText="Contacts" minimizable={true}>
              <div className="flex w-full flex-col px-4">
                {contacts.map(({ name, email, phoneNumber }, index) => {
                  return (
                    <Fragment key={index}>
                      <LineItem label="Name" tag={(name && name.length > 0 && 'success') || 'none'} value={name} />
                      <LineItem label="Email" value={email} />
                      <LineItem label="Contact" last={index + 1 === contacts.length} value={phoneNumber} />
                      {index + 1 < contacts.length && <LineItem label="" value="" />}
                    </Fragment>
                  )
                })}
              </div>
            </Card>
          )}
          <Card cardClassName="mb-4" headerText="Office Hours" minimizable={true}>
            <div className="flex w-full flex-col px-4">
              {officeHourMapping.map(({ label, open, close }, index) => {
                if (!propertyDetails[open]) return
                return (
                  <LineItem
                    key={index}
                    label={label}
                    value={`${getFormatedTime(propertyDetails[open])} - ${getFormatedTime(propertyDetails[close])}`}
                  />
                )
              })}
            </div>
          </Card>
        </div>
      )}
    </>
  )
}
